// src/pages/About.js
import React from 'react';
import { Helmet } from 'react-helmet-async';
import AboutSection from '../components/home/AboutSection';

function About() {
  return (
    <div>
      <Helmet>
        <title>Quem Somos | VitaLink</title>
        <meta name="description" content="Conheça a VitaLink: mais de 1000 clientes, internet 100% fibra óptica e compromisso com estabilidade e suporte local 24/7." />
        <meta name="keywords" content="quem somos, VitaLink, provedor de internet, internet fibra óptica, suporte local" />
        <meta name="author" content="VitaLink" />
        <link rel="canonical" href="https://vitalink.com.br/about" />
        {/* Open Graph */}
        <meta property="og:type" content="article" />
        <meta property="og:title" content="Quem Somos | VitaLink" />
        <meta property="og:description" content="Saiba mais sobre nossa missão, estrutura e compromisso com conexão estável e atendimento de qualidade." />
        <meta property="og:url" content="https://vitalink.com.br/about" />
        <meta property="og:image" content="https://vitalink.com.br/logo512.png" />
      </Helmet>
      <AboutSection />
    </div>
  );
}

export default About;
